import Tween from 'gsap-promise';
import { isEmail } from 'validator';
import XHR from 'bpm-xhr';

import { bindEvents, addListener, removeListener, offset } from '../../assets/js/helpers';

export const selector = 'main-footer';

export default class Footer {

	constructor(section) {
		this.el = {
			section,
			input: section.querySelector('input'),
			form: section.querySelector('form'),
			links: document.querySelectorAll('[data-footer-link]')
		};

		this.url = this.el.form.action;
		this.scrollObj = { top: 0 };

		this.events = bindEvents(this);
		this.addEventListeners();
	}

	scrollIntoView() {
		this.scrollObj.top = window.pageYOffset;

		const top = offset.top(this.el.section);

		return Tween.to(this.scrollObj, 1.0, {
			top,
			ease: Power3.easeInOut,
			onUpdate: () => {
				window.scrollTo({ top: this.scrollObj.top });
			}
		});
	}

	submitForm() {
		new XHR('json')
			.setHeader('Accept', 'application/json')
			.post(this.url, new FormData(this.el.form))
			.then(xhr => {
				if (xhr.response.success) {
					this.el.form.classList.add('is-submitted');
				} else {
					this.el.form.classList.add('is-error');
				}
			})
			.catch((status) => {
				console.warn(src, status);
				this.el.form.classList.add('is-error');
			});
	}

	showFormErrors() {
		this.el.input.parentNode.classList.add('is-error');
	}

	_onLinkClick(e) {
		e.preventDefault();

		this.scrollIntoView().then(() => {
			this.el.input.focus();
		});
	}

	_onFormSubmit(e) {
		e.preventDefault();

		this.el.input.classList.remove('is-error');

		if (isEmail(this.el.input.value)) {
			this.submitForm();
		} else {
			this.showFormErrors();
		}
	}

	_onInputChange() {
		this.el.input.parentNode.classList.remove('is-error');
	}

	addEventListeners() {
		addListener(this.el.links, 'click', this.events._onLinkClick);
		this.el.form.addEventListener('submit', this.events._onFormSubmit);
		this.el.input.addEventListener('keyup', this.events._onInputChange);
		this.el.input.addEventListener('focus', this.events._onInputChange);
	}

	removeEventListeners() {
		removeListener(this.el.links, 'click', this.events._onLinkClick);
		this.el.form.removeEventListener('submit', this.events._onFormSubmit);
	}

	destory() {
		this.removeEventListeners();
	}

}
